import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import UserInfo from "../../elements/account/UserInfo";
import TabPanel from "../../elements/tab/materialTabPanel";
import { useTranslation } from "react-i18next";

import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";

import { StyledTabsBody, StyledTabsHead, StyledTabsWrapper } from "../../styles/styledTabs";
import { StyledAccountWrapper } from "../styledAccount";

const AccountContainer = () => {
  const { t } = useTranslation("accountPage");
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <StyledAccountWrapper>
      <Helmet>
        <title>{t("meta.title")}</title>
      </Helmet>
      <StyledTabsWrapper>
        <StyledTabsHead className="tab-head">
          <h4 className="tab-head__title">
            {t("tabs.title")}
          </h4>
          <Tabs
            value={value}
            indicatorColor="secondary"
            onChange={handleChange}
            orientation="vertical"
            className="tab-head-buttons"
          >
            <Tab label={t("tabs.mainData")} />
          </Tabs>
        </StyledTabsHead>
        <StyledTabsBody className="tab-body">
          <TabPanel
            value={value}
            index={0}
          >
            <UserInfo />
          </TabPanel>
        </StyledTabsBody>
      </StyledTabsWrapper>
    </StyledAccountWrapper>
  );
};

export default AccountContainer;